import Keycloak from "keycloak-js";
// import { RedurectHome } from "./ToggleViews";
import { BroadcastChannel } from "broadcast-channel";
import { recordError } from "../utils/logService";

const configs = {
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  url: process.env.REACT_APP_KEYCLOAK_BASE_URL,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
};

if (process.env.NODE_ENV !== "development") {
  configs.realm = window._CONFIGS.REACT_APP_KEYCLOAK_REALM;
  configs.url = window._CONFIGS.REACT_APP_KEYCLOAK_BASE_URL;
  configs.clientId = window._CONFIGS.REACT_APP_KEYCLOAK_CLIENT_ID;
}

const keycloak = new Keycloak(configs);

const passwordUrl =
  configs.url +
  "/realms/" +
  configs.realm +
  "/login-actions/reset-credentials?client_id=" +
  configs.clientId;
const authChannel = new BroadcastChannel("authchannel");

/**
 * Initializes Keycloak instance
 * Calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */
export const initKeycloak = async (onAuthenticatedCallback) => {
  const keyCloakInstance = {
    initialized: false,
    failedToStart: false,
  };

  await keycloak
    .init({
      pkceMethod: "S256",
      onLoad: "check-sso",
      checkLoginIframe: true,
    })
    .then((initialized) => {
      if (initialized) {
        storeToken();
        onAuthenticatedCallback();
        keyCloakInstance.initialized = initialized;
      }
      return keyCloakInstance;
    })
    .catch((error) => {
      console.log("AN ERROR HAS OCCURED WHILE INIT", error);
      keyCloakInstance.failedToStart = true;
    });
  return keyCloakInstance;
};

export const extendSession = (minValidity = 120) => {
  keycloak
    .updateToken(minValidity)
    .then((res) => {
      storeToken();
      return res;
    })
    .catch((err) => {
      console.error("AN ERROR HAS OCCURED WHILE EXTENDING SESSION", err);
      recordError(err);
      return err;
    });
};

export const isAuthorizedRole = (roles) => {
  if (isAuthenticated() && roles) {
    return roles.some((r) => {
      const realm = keycloak.hasRealmRole(r);
      const resource = keycloak.hasResourceRole(r);

      return realm || resource;
    });
  }
  return false;
};

export const isAuthenticated = () => {
  const response =
    keycloak != null && keycloak.authenticated && localStorage.getItem("token");

  return response;
};

export const logout = () => {
  //if (isAuthenticated()) {

  authChannel.postMessage("User has logged out");

  localStorage.clear();
  keycloak.logout({ redirectUri: window.location.origin + "/" });
  //}
};

export const clearToken = (isAnon, key = "") => {
  const params = key ? `/login/${key}/${isAnon}` : "/";

  if (isAuthenticated()) {
    localStorage.clear();
    keycloak.logout({ redirectUri: `${window.location.origin}${params}` });
  }
};

export const login = () => {
  if (!isAuthenticated()) {
    keycloak
      // .login({ redirectUri: `${window.location.origin}/nys/candidate/create` })
      .login({ redirectUri: `${window.location.origin}/my-dashboard` })
      .then((authenticated) => {
        if (authenticated) {
          // console.log("User has successfully logged in..!");
          localStorage.setItem("token", keycloak.token);
        }
      });
  }
};

export const hasTokenExpired = () => {
  const expired = keycloak.isTokenExpired();

  if (expired) {
    //! redirect keycloak login is not working as yet
    // const fullURL = loginURL + window.location.href;
    clearToken();
  }
  return expired;
};

//? TOKEN IS EXTENDED WITH 5 MINUTES
export const updateToken = (successCallback) => {
  const isLogged = isAuthenticated();

  if (isLogged) {
    keycloak
      .updateToken(120)
      .then((authenticated) => {
        storeToken();
        return successCallback;
      })
      .catch((error) => {
        recordError(error);
        logout();
      });
  }
};

export const getUsername = () => {
  const response = isAuthenticated() && keycloak.tokenParsed.given_name;
  return response;
};

export const getProfile = () => {
  const loggedIn = isAuthenticated();

  return {
    emailAddress: loggedIn ? keycloak.idTokenParsed.email : "",
    firstName: loggedIn ? keycloak.idTokenParsed.given_name : "",
    lastName: loggedIn ? keycloak.idTokenParsed.family_name : "",
    userId: loggedIn ? keycloak.idTokenParsed.sub : "",
    expiryTime: loggedIn ? keycloak.idTokenParsed.exp : "",

    // roles: "ADMIN,Core",
  };
};

export const passwordReset = () => {
  return passwordUrl;
};

export const getLogInOutText = () => {
  return isAuthenticated() ? "Logout" : "Login";
};

export const getToken = () => {
  return localStorage.getItem("token");
};

export const storeToken = () => {
  if (keycloak.token) {
    localStorage.setItem("token", keycloak.token);
  }
};

export const logoutInstanceEventListener = () => {
  authChannel.onmessage = (event) => {
    logout();
    authChannel.close();
  };
};
